<template >
  <div class="info">
    <div class="info_title">请填写申请信息，审核通过后会进行短信或邮件通知。</div>
    <div class="info_main">
      <van-form @submit="onSubmit" label-width="5rem" @failed="onFailed">
        <van-field
          v-model.trim="username"
          required
          name="姓名"
          label="姓名"
          placeholder="请填写正确的姓名"
          :rules="[{ required: true,pattern, message: '请填写正确的姓名' }]"
        />
        <div class="info_field info_field_required">
          <span
            style="-webkit-box-flex: 0; -webkit-flex: none;flex: none;box-sizing: border-box;width: 5rem;margin-right: 12px;color: #646566;text-align: left;word-wrap: break-word;"
          >学校</span>
          <span style="width:90%;color:#BBBBBB" @click="checkSchool()">
            <span
              :class="{'info_err_msg':schoolValidator}"
              v-if="schoolName"
              style="color:black"
            >{{schoolName}}</span>
            <span :class="{'info_err_msg':schoolValidator}" v-else>请单击选择学校</span>
            <img
              src="./../assets/imgs/more@2x.png"
              alt
              srcset
              style="height:1rem;float:right;transform: translate(-50%,50%);"
            />
          </span>
        </div>
        <van-field
          v-model.trim="deport"
          required
          name="院系"
          label="院系"
          placeholder="请填写正确的院系"
          :rules="[{ required: true, pattern, message: '请填写正确的院系' }]"
        />
        <van-field
          v-model.trim="domain"
          required
          name="研究领域"
          label="研究领域"
          placeholder="请填写正确的研究领域"
          :rules="[{ required: true, pattern, message: '请填写正确的研究领域' }]"
        />
        <div class="info_tip">请填写联系方式，完整的信息有助于享受更加完善的服务</div>
        <van-field
          v-model.trim="email"
          name="邮箱地址"
          label="邮箱地址"
          required
          placeholder="请填写有效邮箱便于接收申请通知"
          :rules="[{ required: true,validator:emailValidator, message: '请填写有效邮箱便于接收申请通知' }]"
        />
        <van-field
          v-model.trim="phone"
          name="手机号码"
          label="手机号码"
          placeholder="请填写正确的手机号码"
          :rules="[{ validator:phoneValidator, message: '请输入正确的手机号' }]"
        />
        <div class="info_field">
          <span
            style="-webkit-box-flex: 0; -webkit-flex: none;flex: none;box-sizing: border-box;width: 5rem;margin-right: 12px;color: #646566;text-align: left;word-wrap: break-word;"
          >身份</span>
          <span style="width:90%;color:#BBBBBB" @click="checkIdentifiy()">
            <span :class="{'info_err_msg':identifiyValidator}" v-if="!identifiy">请单击选择身份</span>
            <span
              :class="{'info_err_msg':identifiyValidator}"
              style="color:black"
              v-else
            >{{identifiy =='teacher'?'教师':(identifiy == 'student'?'学生':(identifiy == 'staff'?'其他':'请单击选择身份'))}}</span>
            <img
              src="./../assets/imgs/more@2x.png"
              alt
              srcset
              style="height:1rem;float:right;transform: translate(-50%,50%);"
            />
          </span>
        </div>
        <div style="margin: 16px;">
          <van-button round block type="info" native-type="submit">提交</van-button>
        </div>
      </van-form>
    </div>
    <!-- 身份弹出框 -->
    <van-overlay :show="show" @click="show = false">
      <div class="wrapper" @click.stop>
        <div class="block">
          <div class="block_head">
            <span @click="show = false">取消</span>
            <span style="font-size:1.5rem;font-weight: bold;">设置身份</span>
            <span class="block_btn" @click="accomplish()">完成</span>
          </div>
          <div v-for="(item, index) in identifiyList" :key="index">
            <div @click="checkedItem(item)" class="block_item">
              <span>{{item.name}}</span>
              <img
                src="./../assets/imgs/checked_identify@2x.png"
                alt
                srcset
                style="height: 1rem;"
                v-show="item.checked"
              />
            </div>
          </div>
        </div>
      </div>
    </van-overlay>
    <!-- 身份弹出框 -->
    <!-- 学校选择 -->
    <van-overlay :show="search_school_show"></van-overlay>
  </div>
</template>
<script>
import { Toast } from "vant";
import user_service from "./../service/user_service";
export default {
  data() {
    return {
      username: "",
      phone: "",
      school: "",
      deport: "",
      identifiy: "",
      domain: "",
      email: "",
      schoolValidator: false,
      identifiyValidator: false,
      identifiyList: [
        { id: "teacher", name: "教师", checked: true },
        { id: "student", name: "学生", checked: false },
        { id: "staff", name: "其他", checked: false }
      ],
      show: false,
      search_school_show: false,
      schoolList: [],
      allSchoolList: [],
      schoolName: "",
      pattern: /^[a-zA-Zu4e00-\u9fa5]{1}[a-zA-Z-,;/()\u4e00-\u9fa5]{1,16}$/
    };
  },
  async created() {
    this.username = sessionStorage.getItem("username") || "";
    this.deport = sessionStorage.getItem("deport") || "";
    this.domain = sessionStorage.getItem("domain") || "";
    this.email = sessionStorage.getItem("email") || "";
    this.phone = sessionStorage.getItem("phone") || "";
    this.identifiy = sessionStorage.getItem("identifiy") || "";
    // this.schoolValidator = this.school || this.schoolName ? false : true;
    this.schoolName =
      this.$route.query.sName || this.$route.query.addName || "";
    this.school = this.$route.query.sId || "";
    console.log(sessionStorage.getItem("identifiy"),'---->')
     let result = await user_service.getReapply();
    if (result.data == 1 ||0) {
      this.$router.push("/");
    }

  },
  beforeDestroy() {
    sessionStorage.setItem("username", this.username||'');
    sessionStorage.setItem("deport", this.deport||'');
    sessionStorage.setItem("domain", this.domain||'');
    sessionStorage.setItem("email", this.email || '');
    sessionStorage.setItem("phone", this.phone || '');
    sessionStorage.setItem("identifiy", this.identifiy || '');
  },
  methods: {
    // 邮箱校验
    emailValidator(value) {
      if (value.trim()) {
        console.log(value);
        return value.indexOf("@") > -1;
      }
    },
    // 手机号校验
    phoneValidator(value) {
      if (value.trim()) {
        return /^\d{11}$/.test(value);
      }
    },
    async onSubmit(values) {
      console.log("submit", values);
   
      console.log(this.identifiy, this.identifiyValidator);
      this.schoolValidator = this.school || this.schoolName ? false : true;
      // this.identifiyValidator = this.identifiy ? false : true;
      if (!this.schoolValidator) {
        let result = await user_service.commitApply({
          iphone: this.phone,
          userName: this.username,
          school: this.schoolName,
          dept: this.deport,
          email: this.email,
          schoolId: this.school,
          researchArea: this.domain,
          userIdentity: this.identifiy
        });
        console.log(result);
        if (result.code == 200) {
          this.$router.push("/result");
        } else if (result.code == 401) {
          Toast.fail("请勿重复提交");
        }
      }
    },
    onFailed(errorInfo) {
      console.log("failed", errorInfo);
      this.schoolValidator = this.school || this.schoolName ? false : true;
      // this.identifiyValidator = this.identifiy ? false : true;
    },
    checkIdentifiy() {
      this.show = true;
      for (const iterator of this.identifiyList) {
        iterator.checked = false;
        if (this.identifiy == iterator.id) {
          iterator.checked = true;
        }
      }
    },

    checkedItem(item) {
      for (const iterator of this.identifiyList) {
        iterator.checked = false;
        if (item.id == iterator.id) {
          iterator.checked = true;
        }
      }
    },
    accomplish() {
      for (const iterator of this.identifiyList) {
        if (iterator.checked) {
          this.identifiy = iterator.id;
        }
      }
      this.show = false;
    },
    checkSchool() {
      this.$router.push("/schoolList");
    }
  }
};
</script>
<style scoped>
.info {
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  background: #ffffff;
}
.info_title {
  height: 5rem;
  background: linear-gradient(90deg, #319cc4 0%, #317bd2 50%, #6471d0 100%);
  text-align: center;
  line-height: 5rem;
  font-size: 1rem;
  font-weight: 400;
  color: #ffffff;
}
.info_tip {
  background: #f5f5f5;
  height: 3rem;
  padding-left: 1rem;
  padding-right: 1rem;
  margin-left: 2rem;
  margin-right: 2rem;
  line-height: 3rem;
  text-align: center;
  color: #999999;
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.info_field {
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  box-sizing: border-box;
  width: 100%;
  padding: 10px 16px;
  overflow: hidden;
  color: #646566;
  font-size: 14px;
  line-height: 24px;
  background-color: #fff;
}
.info_field ::after {
  position: absolute;
  box-sizing: border-box;
  content: " ";
  pointer-events: none;
  right: 16px;
  bottom: 0;
  left: 16px;
  border-bottom: 1px solid #ebedf0;
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
}
.info_field_required::before {
  position: absolute;
  left: 8px;
  color: #ee0a24;
  font-size: 14px;
  content: "*";
}
.info_err_msg {
  color: #ee0a24;
}
.wrapper {
  height: 100%;
  /* overflow-y: scroll; */
  background-color: #fff;
}
.block {
  background-color: #fff;
  width: 100%;
  height: 100%;
  margin: 0 auto;
}
.block_head {
  background: linear-gradient(90deg, #319cc4 0%, #317bd2 50%, #6471d0 100%);
  height: 5rem;
  line-height: 5rem;
  font-size: 1.2rem;
  color: #ffffff;
  display: flex;
  justify-content: space-between;
  padding: 0 1rem;
}
.block_btn {
  line-height: 3rem;
  margin: 1rem 1rem;
  box-sizing: border-box;
  padding: 0 2rem;
  background: #009bfe;
  border-radius: 1.5rem;
}
.block_item {
  /* background: #eeeeee; */
  margin: 0 1rem;
  height: 4rem;
  line-height: 4rem;
  color: #666666;
  font-size: 1.3rem;
  border-bottom: 1px solid #eeeeee;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.van-search__action {
  color: #aaaaaa;
}
.add_btn {
  font-size: 1.5rem;
  height: 4rem;
  width: 30%;
  padding-left: 2rem;
  padding-right: 2rem;
  line-height: 4rem;
  background: #009bfe;
  border-radius: 3rem;
  display: inline-block;
  color: #ffffff;
}
.van-overlay {
  overflow: auto;
}
</style>


// WEBPACK FOOTER //
// src/components/info.vue